import app from './app';
import { QUOTE_SERVICE_URL } from "../../libs/constants";

const getDirectCustomerCTInitialQuotes = (searchConfig, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = QUOTE_SERVICE_URL + "/list/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getDirectCustomersCTQuotes"
        }
    };

    dispatch(app.setLoading(true));

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data.quoteViewList) {
                dispatch({
                    type: "SET_DIRECT_CUSTOMER_CT_INITIAL_QUOTES",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const getDirectCustomerCTInitialQuoteDetails = (userId, quoteId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const url = QUOTE_SERVICE_URL + "/" + userId + "/" + quoteId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getQuoteDetails"
        }
    };

    await api.post(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_DIRECT_CUSTOMER_CT_INITIAL_QUOTE_DETAILS",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const uploadRevitalizeMappingFormFile = (requestData, fileName, userId, quoteId) => async (dispatch, getState, api) => {
    const modalObject = {
        type: "info",
        messageText: "Revitalize mapping file uploaded succesfully!",
        rounded: true,
        hideConfirmationButtons: false,
        iconToRender: "ACCEPT_ICON",
    }
    
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    await api.post(QUOTE_SERVICE_URL + "/ctRevMapping/upload/" + userId + "/" + quoteId, requestData, config)
        .then(response => {
            if (response.data) {
                dispatch(setMappingFileName(fileName));
                dispatch(setMappingFileUploadStatus("success"));
                dispatch(getDirectCustomerCTInitialQuoteDetails(userId, quoteId));
                dispatch(app.setAppModal(modalObject));
            }
            else {
                dispatch(setMappingFileUploadStatus("error"));
            }
        })
        .catch(error => {
            dispatch(setMappingFileUploadStatus("error"));
        });
};

const uploadRevitalizePricingFormFile = (requestData, fileName, userId, quoteId) => async (dispatch, getState, api) => {
    const modalObject = {
        type: "info",
        messageText: "Revitalize prices file uploaded succesfully!",
        rounded: true,
        hideConfirmationButtons: false,
        iconToRender: "ACCEPT_ICON",
    }

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    await api.post(QUOTE_SERVICE_URL + "/uploadQuotePrice/" + userId + "/" + quoteId, requestData, config)
        .then(response => {
            if (response.data) {
                dispatch(setPricingFileName(fileName));
                dispatch(setPricingFileUploadStatus("success"));
                dispatch(getDirectCustomerCTInitialQuoteDetails(userId, quoteId));
                dispatch(app.setAppModal(modalObject));
            }
            else {
                dispatch(setPricingFileUploadStatus("error"));
            }
        })
        .catch(error => {
            dispatch(setPricingFileUploadStatus("error"));
        });
};

const updateRevitalizeHpPriceStatus = (updatedStatus, userId, quoteId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "updateRevitalizeHpPriceStatus" } };
        await api.post(QUOTE_SERVICE_URL + '/updateQuoteHpPriceStatus/' + userId + '/' + quoteId, updatedStatus, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const setMappingFileName = fileName => {
    return {
        type: "SET_MAPPING_FILE_NAME",
        data: fileName
    }
}

const setMappingFileUploadStatus = status => {
    return {
        type: "SET_MAPPING_FILE_UPLOAD_STATUS",
        data: status
    }
}

const setPricingFileName = fileName => {
    return {
        type: "SET_PRINCING_FILE_NAME",
        data: fileName
    }
}

const setPricingFileUploadStatus = status => {
    return {
        type: "SET_PRICING_FILE_UPLOAD_STATUS",
        data: status
    }
}

const ctQuoteActions = {
    getDirectCustomerCTInitialQuotes,
    getDirectCustomerCTInitialQuoteDetails,
    uploadRevitalizeMappingFormFile,
    uploadRevitalizePricingFormFile,
    updateRevitalizeHpPriceStatus,
    setMappingFileName,
    setMappingFileUploadStatus,
    setPricingFileName,
    setPricingFileUploadStatus,
}

export default ctQuoteActions;